import Step from 'shepherd.js/src/types/step';
import {TourSteps} from './interface/tour-steps.interface';

export const goToMealPlansStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons}: TourSteps): Step.StepOptions[] => {
    return  [{
      ...steps.default,
      id: 'mealPlans1',
      title: '¡Vamos a crear tu primer plan de alimentación!',
      text: `Da clic en "Mis planes de alimentación" para poder continuar.`,
      cancelIcon: {enabled: false},
      attachTo: {
        element: '.l-item-1-1',
        on: 'bottom'
      },
      advanceOn: {
        selector: '.l-item-1-1',
        event: 'click'
      },
      buttons: [
        {
          ...buttons.cancel,
        }
      ],
      beforeShowPromise: () => {
        return new Promise((resolve): void => {
          setTimeout((): void => {
            resolve(true);
          }, 1000);
        });
      },
      classes: 'shepherd shepherd-open shepherd-theme-square shepherd-transparent-text',
    }];
  };
